import PropTypes from 'prop-types'
import {
  GrayBlock,
  GrayBlockContent,
  Header,
  OuterCard,
  UpdatedAt,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/styled-components'

const CommunicationBoardCard = ({ sectionKey, sectionData, t }) => {
  return (
    <OuterCard>
      <Header>{t(`subscriptionTools:communication_board.board_${sectionKey}`)}</Header>
      {sectionData.updated_at && (
        <UpdatedAt>
          {t('subscriptionTools:communication_board.legacy_last_updated', {
            date: new Date(sectionData.updated_at).toLocaleString(),
          })}
        </UpdatedAt>
      )}
      <GrayBlock>
        <GrayBlockContent dangerouslySetInnerHTML={{ __html: sectionData.content || '' }} />
      </GrayBlock>
    </OuterCard>
  )
}

CommunicationBoardCard.propTypes = {
  sectionKey: PropTypes.string.isRequired,
  sectionData: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default CommunicationBoardCard
